import { styled } from '$utils/theme'

interface Props {
  color?: string
  noTop?: boolean
  bottom?: boolean
  height?: number
  background?: string
}

export const Background = styled.div<Props>`
  position: relative;
  top: ${p => (p.noTop ? 'auto' : '3rem')};
  ${p => p.theme.media.desktop`top:${p.noTop ? 'auto' : '4.5rem'}`};
  background-color: ${p => p.theme.colors[p.color]};
  width: 100%;
  margin: 0;
  ${p =>
    p.bottom &&
    `
  bottom: 0;
  position: absolute;
  `}
  ${p => p.height > 0 && `height: ${p.height}vh`}
  ${p =>
    p.background &&
    `
  background: ${p.background};
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/Background/Background.ts